module.exports = __webpack_public_path__ + "img/13.62f5c7bf.jpg";